import React, { useState, useEffect } from 'react'
import rgbToHex from './utils'

const SingleColor = ({ rgb, weight, index, hexColor }) => {
  const [alert, setAlert] = useState(false)
  const hex = rgbToHex(...rgb)
  const bcg = rgb.join(',');

  const hexValue = `#${hexColor}`

  useEffect(() => {
    const timeout = setTimeout(() => {
      setAlert(false);

    }, 3000)
    return () => clearTimeout(timeout);
  }, [alert])
  return <article onClick={() => {
    setAlert(true);
    navigator.clipboard.writeText(hexValue);

  }}
    className={`color ${index > 100 && 'color-light'}`}
    style={{ backgroundColor: `rgb(${bcg})` }} >
    <p className='percent-value'>{weight}%</p>
    <p className='color-value'>{hexValue}</p>
    {alert && <p className='alert'>copied to clipboard</p>}
  </article >
}

export default SingleColor
